import { render, staticRenderFns } from "./ProgramTeamsTable.vue?vue&type=template&id=66a41b38&scoped=true&lang=pug&"
import script from "./ProgramTeamsTable.vue?vue&type=script&lang=js&"
export * from "./ProgramTeamsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a41b38",
  null
  
)

export default component.exports